let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cMN4p")).then(() => parcelRequire('2UC7n'));